import { render, staticRenderFns } from "./ExtensionPresetCard.vue?vue&type=template&id=2cdb1380&scoped=true&"
import script from "./ExtensionPresetCard.vue?vue&type=script&lang=js&"
export * from "./ExtensionPresetCard.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionPresetCard.vue?vue&type=style&index=0&id=2cdb1380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdb1380",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VBtnToggle,VProgressCircular})
